export const PER_PAGE_OPTIONS: readonly number[] = [10, 20, 30, 50, 100];

export const DEFAULT_PAGE: number = 1;

export const DEFAULT_PER_PAGE: number = 10;

export const PAGINATION_LABELS = {
  ROWS_PER_PAGE: "Linhas por página",
  PREVIOUS: "Página anterior",
  NEXT: "Próxima página",
} as const;
